export async function getDataStaffCourseRequests(params: string) {
  try {
    const response = await fetch(
      `/internal-api/employee/education/courses/by-positions?${params}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
  }
}
